import React, { useState, useEffect, useRef, useCallback } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  Character,
  CharacterSpell,
  CharacterAction,
  CharacterAbility,
  CharacterSheetInterface,
  Attack,
  CharacterItem,
  Ability,
  StoredSpell,
  SpellsFromList,
  SpellsFromListWithCosts,
  CreatureAbility,
  CharacterFeature,
  // CharacterWeapon,
} from "@dndModels";

// import API from "../../../utilities/system_api";
// import DataUtilities from '../../../utilities/common_utilities';
import DandDCharacterUtilities from "@dndUtilities/char_utilities";

import CharacterActionInput from "@dndComponents/character/spells_and_abilities/CharacterActionInput";

import ModalOrDrawer from "@components/display/ModalOrDrawer";
import CharacterSpellDetails from "@dndComponents/character/spells_and_abilities/CharacterSpellDetails";
import CharacterItemDetailsSidebar from "@dndComponents/character/inventory/CharacterItemDetailsSidebar";
import CharacterAttackSidebar from "@dndComponents/character/inventory/CharacterAttackSidebar";
import DisplayStringWithReplacementsRecursive from '@dndComponents/display/DisplayStringWithReplacementsRecursive';
import LoadingBox from '@components/input/LoadingBox';

interface Props {
  character: Character;
  char_interface: CharacterSheetInterface;
  shared?: boolean;
}

// const api = API.getInstance();
// const common_util = DataUtilities.getInstance();
const char_util = DandDCharacterUtilities.getInstance();

export default function CharacterPassives({
  character,
  char_interface,
  shared = false,
}: Props) {
  const [fetched, setFetched] = useState(false);
  const [real_reloading, setRealReloading] = useState(false);
  const [reloading, setReloading] = useState(false);
  const [reloading_costs, setReloadingCosts] = useState(false);
  
  const [drawer, setDrawer] = useState("");
  const [details_action, setDetailsAction] = useState<CharacterAction | CharacterFeature | null>(null);
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  const actionsChanged = useCallback(() => {
    setRealReloading(true);
  }, []);

  useEffect(() => {
    if (!fetched) {
      character.subscription_holder.subscribe("Recalculated", mounted, recalculated);
      character.subscription_holder.subscribe("Actions", mounted, actionsChanged);
      // console.log(id);
      setFetched(true);
    }
  }, [fetched]);

  const recalculated = () => {
    // console.log("Actions");
    setReloading(true);
  }
  
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);
  
  useEffect(() => {
    if (real_reloading) {
      setRealReloading(false);
    }
  }, [real_reloading, setRealReloading]);
  
  useEffect(() => {
    if (reloading_costs) {
      setReloadingCosts(false);
    }
     
  }, [reloading_costs, setReloadingCosts]);

  const validAction = (o: CharacterAction) => {
    // if (o.name.includes("Find Famil")) {
    //   debugger;
    // }
    if (o.action instanceof Attack) {
      // return !character.unarmed_strike_customizations.hidden;
    } else {
      if (o.action instanceof CharacterSpell) {
        if (o.action.hidden) {
          return false;
        } else if (!o.lowest) {
          return o.action.show_upcasts.includes(o.level);
        } else if (o.ritual_only && o.action.hide_ritual) {
          return false;
        } else if (o.action.ritual) {
          return false;
        } else {
          return true;
        }
      } else if (o.action instanceof StoredSpell) {
        if (o.action.hidden) {
          return false;
        } else {
          return true;
        }
      } else if (o.action instanceof CharacterAbility) {
        if (o.action.ritual) {
          return false;
        } else if (o.action.the_ability instanceof SpellsFromList || 
          o.action.the_ability instanceof SpellsFromListWithCosts) {
          if (o.special_resource) {
            return !o.action.hide_special;
          } else if (!o.lowest) {
            return o.action.show_upcasts.includes(o.level);
          } else if (o.ritual_only && o.action.hide_ritual) {
            return false;
          } else if (o.action.hidden) {
            return false;
          } else {
            return true;
          }
        } else if (o.action.the_ability instanceof Ability) {
          if (o.special_resource) {
            return !o.action.hide_special;
          } else if (o.action.hidden) {
            return false;
          } else {
            return true;
          }
        } else if (o.action.hidden) {
          return false;
        } else if (o.action.the_ability instanceof CreatureAbility) {
          return true;
        } else {
          // console.log(o);
          return true;
        }
      } else {
        // console.log(o);
        return true;
      }
    }
    return true;
  }

  const renderActionGroup = () => {
    const log_it = false; // group === "Actions"; // group === "Bonus Actions"; // 
    if (char_interface instanceof Character) {
      if (log_it) {
        console.log(char_interface.actions); // .filter(o => o.name.includes("Drink"))
        debugger;
      }
      // let filtered = char_interface.actions;
      let filtered = char_interface.actions.filter(o => o.is_passive && validAction(o));
      filtered = filtered.filter(o => 
        !(o.action instanceof CharacterAbility) || 
        !(o.action.the_ability instanceof Ability) ||
        o.action.the_ability.show_in.includes("Actions"));
      // filtered = filtered.filter(o => o.name.includes("Unseen"));
      if (log_it) {
        console.log(char_interface.actions);
        console.log(filtered);
        debugger;
      }
      if (filtered.length > 0) {
        return (
          <>
            <Grid
              style={{ 
                fontWeight: "bold", 
                fontSize: "12px"
              }}
              container
              spacing={0}
              direction="row"
              size={{
                xs: 12
              }}>
              <Grid
                className="centered"
                size={3}>Name</Grid>
              <Grid
                container
                spacing={0}
                direction="row"
                size={9}>
                <Grid
                  className="centered"
                  size={3}>Cost/When</Grid>
                <Grid
                  className="centered"
                  size={{
                    xs: 3
                  }}>Range/Area</Grid>
                <Grid
                  className="centered"
                  size={{
                    xs: 3
                  }}>Attack/DC</Grid>
                <Grid
                  className="centered"
                  size={{
                    xs: 3
                  }}>Effect</Grid>
              </Grid>
            </Grid>
            { renderActionsOfType(filtered) }
          </>
        );
      }
    }
    return null;
  }

  const renderActionsOfType = (actions: CharacterAction[]) => {
    const log_it = false; // type === "Special"; // group === "Actions"; // 
    if (log_it) {
      console.log(actions);
      // actions = actions.filter(o => o.name.includes("Drink"));
      debugger;
    }
    return (
      <>
        { actions.map(action => {
          if (reloading) {
            return null;
          } else {
            return (
              <Grid size={12}
                key={`${action.true_id}_${action.type}_${action.level}_${action.slot}`}
                style={{ 
                  fontSize: "12px"
                }}>
                <CharacterActionInput
                  char={character}
                  char_interface={char_interface}
                  action={action}
                  group={action.casting_time}
                  shared={shared}
                  level={action.level}
                  // casting_time_cost
                  show_casting_time
                  onOpen={() => {
                    setDetailsAction(action);
                    setDrawer("details");
                  }}
                />
              </Grid>
            );
          }
        })}
      </>
    );
  }

  const renderExtras = () => {
    const action = details_action;
    const open = drawer === "details";
    if (open) {
      if (action instanceof CharacterAction) {
        // console.log(action);
        let char_item: CharacterItem | undefined = undefined;
        if (action.action instanceof CharacterItem) {
          char_item = action.action;
        } else {
          if (action.action instanceof CharacterAbility && action.action.item_id !== "") {
            const item_id = action.action.item_id;
            char_item = character.inventory.items.find(o => o.true_id === item_id);
          }
        }
        return (
          <>
            <ModalOrDrawer
              open={ drawer === "details" } 
              onClose={() => {
                setDrawer("");
                character.subscription_holder.modalClosed();
              }}>
              { char_item ? 
                <CharacterItemDetailsSidebar
                  character={character}
                  char_item={char_item}
                  action={action}
                  shared={shared}
                  onRemove={() => {
                    character.changed();
                    character.subscription_holder.resourcesChanged();
                    character.subscription_holder.recalculate();
                    setDrawer("");
                  }}
                  // onTransform={onTransform}
                /> 
              : (action.action instanceof CharacterSpell || 
                action.action instanceof CharacterAbility) ? 
                <CharacterSpellDetails
                  character={character}
                  char_interface={char_interface}
                  obj={ action.action }
                  level={ action.level }
                  type={action.type}
                  action={action}
                  shared={shared}
                  onObjChange={(obj: CharacterSpell | CharacterAbility) => {
                    if (obj instanceof CharacterSpell) {
                      const char = char_interface;
                      const spell_finder = char.mind.spells.filter(o => o.true_id === obj.true_id);
                      if (spell_finder.length === 1) {
                        const char_spell = spell_finder[0];
                        char_spell.copy(obj);
                        char.subscription_holder.recalculate();
                        character.changed();
                      } else {
                        console.error("Spell Find Error:");
                        console.error(obj);
                        console.error(spell_finder);
                        console.error(char.mind.spells);
                      }
                    } else {
                      const char = char_interface;
                      let ability_finder = char.mind.abilities.filter(o => o.true_id === obj.true_id);
                      if (ability_finder.length === 0) {
                        ability_finder = char.mind.spell_as_abilities.filter(o => o.true_id === obj.true_id);
                      }
                      if (ability_finder.length === 1) {
                        const char_ability = ability_finder[0];
                        char_ability.copy(obj);
                        char.subscription_holder.recalculate();
                        character.changed();
                      } else {
                        console.error("Ability Find Error:");
                        console.error(obj);
                        console.error(ability_finder);
                        console.error(char.mind.abilities);
                      }
                    }
                  }}
                  onClose={() => {
                    setDrawer("");
                    // setLevel(null);
                  }}
                  // onTransform={() => {
                  //   onTransform();
                  // }}
                  // onSourceChange={onCharChange}
                /> 
              : action.action instanceof Attack && 
                <CharacterAttackSidebar
                  character={character}
                  attack={action.action}
                />
              }
            </ModalOrDrawer>
          </>
        );
      } else if (action instanceof CharacterFeature) {
        return (
          <>
            <ModalOrDrawer
              open={ drawer === "details" } 
              onClose={() => {
                setDrawer("");
              }}>
              <Grid container spacing={0} direction="row">
                <Grid size={12} className="header">{ action.name }</Grid>
                <Grid size={12}>
                  <DisplayStringWithReplacementsRecursive cfs={char_interface} display_string={action.description} />
                </Grid>
              </Grid>
            </ModalOrDrawer>
          </>
        );
      }
    }
    return null;
  }

  if (real_reloading) {
    return (<LoadingBox />);
  }
  return (
    <Grid container spacing={0} direction="row" className="curved_border bg_black_transp">
      <Grid size={12} className="header centered">
        Passive Effects
      </Grid>
      { renderActionGroup() }
      { renderExtras() }
    </Grid>
  );
}
